import { render, staticRenderFns } from "./RoleSave.vue?vue&type=template&id=34c93e2c&"
import script from "./RoleSave.vue?vue&type=script&lang=js&"
export * from "./RoleSave.vue?vue&type=script&lang=js&"
import style0 from "./RoleSave.vue?vue&type=style&index=0&id=34c93e2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports